import React from "react";
import {
    useLocation,
    useNavigate,
    useParams,
  } from "react-router-dom";
  
  
  const withRouter = (WrappedComponent) => {
  const WithRouterWrapper = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    return (
      <WrappedComponent
        {...props}
        navigate={navigate}
        params={params}
        router={{ location, navigate, params }}
      />
    );
  };
  WithRouterWrapper.displayName = `withRouter(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return WithRouterWrapper;
};

export default withRouter;
